export const SETTINGS = {
    datetimeFormats: {
        hyphenSeparatedDateTime: "MM-DD-YYYY | hh:mm A",
    },
    dateFormats: {
        slashSeparatedDate: "DD/MM/YYYY",
        hyphenSeparatedDate: "MM-DD-YYYY",
        databaseFormat: "YYYY-MM-DD",
        listingCommonDateFormat: "MM/DD/YYYY",
    },
    timeFormats: {
        timeIn24HoursFormat: "HH:mm:ss",
        timeIn12HoursFormat: "hh:mm A",
    },
    statusOptions: [
        { label: 'All Status', value: -1 },
        { label: 'Active', value: 1 },
        { label: 'Inactive', value: 0 }
    ],
    scanStatusOptions: [
        { label: 'All Scans', value: -1 },
        { label: 'Scan not started', value: 0 },
        { label: 'Active Scan Completed', value: 1 }
    ],
    spiderTypeOptions: [
        { label: 'Ajax Spider', value: 'ajaxSpider' },
    ],
    maxDurationSpiderOptions: [
        { label: '15 Mins', value: '15' },
        { label: '30 Mins', value: '30' },
        { label: '45 Mins', value: '45' },
        { label: '60 Mins', value: '60' },
    ],
    importURLsOptions: [
        { label: 'None', value: 'none' },
        { label: 'OpenAPI Definition', value: 'openapi' },
        { label: 'Postman Collection', value: 'postman' },
        { label: 'import URLs from File', value: 'fileURL' }
    ],
    scanStrengthOptions: [
        { label: 'Low', value: 'Low' },
        { label: 'Medium (Default)', value: 'Medium' },
        { label: 'High', value: 'High' },
    ],
    agentTypeOptions: [
        { label: 'Desktop (Default)', value: 'Desktop' },
        { label: 'Tablet', value: 'Tablet' },
        { label: 'Mobile', value: 'Mobile' },
    ],
   /*  authenticationTypesOptions: [
        { label: 'None', value: 'none' },
        { label: 'Cookie Based Authentication', value: 'jsonCookie' },
        { label: 'JSON-JWT Authentication', value: 'jsonJWT' },
        { label: 'Bearer Token', value: 'bearerToken' },
        { label: 'Ai-Assisted Authentication', value: 'AiAssistedAuth' },
        { label: 'Manual Authentication', value: 'manualAuth' },
        // { label: 'Form Based Authentication (TBD)', value: 'formBased' },
        // { label: 'oAuth Authentication (TBD)', value: 'oAuth' },
    ], */
    authenticationTypesOptions: [
        {
            label: 'Standard Authentication',
            code: 'SA',
            items: [
                { label: 'None', value: 'none' },
                { label: 'Ai-Assisted Authentication', value: 'AiAssistedAuth' },
                { label: 'Bearer Token', value: 'bearerToken' },
                { label: 'Cookie Based Authentication', value: 'jsonCookie' },
                { label: 'JSON-JWT Authentication', value: 'jsonJWT' },
                { label: 'Manual Authentication', value: 'manualAuth' },
            ]
        },
        {
            label: 'Multifactor Authentication',
            code: 'MFA',
            items: [
                { label: '2FA with Email/SMS OTP', value: '2FA-SMS' },
                { label: '2FA with TOTP', value: '2FA-TOTP' },
            ]
        },
    ],
    userRoleOptions: [
        { label: 'Admin Role', value: 'admin' },
        { label: 'Write Role', value: 'readWrite' },
        { label: 'Read-Only Role', value: 'readOnly' },
    ],
        sessionTypeOptions: [
        { label: 'None', value: 'none' },
        { label: 'Authorization Header Session Management', value: 'header-based' },
        { label: 'Cookie Based Session Management', value: 'cookie-based' },
        { label: 'Http Authentication Session Management', value: 'http-based' },
        /* { label: 'Script Based Session Management', value: 'script-based' }, */
    ],
    sessionRefreshMethodOptions: [
        { label: 'POST (Default)', value: 'POST' },
        { label: 'GET', value: 'GET' },
    ],

    scriptTypeOptions: [
        { label: 'None', value: 'None' },
        // { label: 'session', value: 'session' },
        // { label: 'httpsender', value: 'httpsender' },
        // { label: 'HTTP Sender Script', Value: 'httpsender_cookies' },
        { label: 'HTTP Sender Script', value: 'httpsender' },
    ],
    paymentStatusOptions: [
        { label: 'All Status', value: -1 },
        { label: 'Success', value: 'SUCCESS' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Failed', value: 'FAILED' }
    ],
    riskOptions: [
        { label: 'High', value: 'High' },
        { label: 'Medium', value: 'Medium' },
        { label: 'Low', value: 'Low' },
        { label: 'Informational', value: 'Informational' },
        { label: 'False Positives', value: 'False Positives' },
    ],
    scanHistoryOptions: [
        { label: 'All Status', value: -1 },
        // {label: 'Pending', value: "Pending"},
        { label: 'Running', value: "STARTING PASSIVE SCAN"},
        { label: 'Finished', value: "ACTIVE SCAN COMPLETED"},
        { label: 'Failed', value: "ACTIVE SCAN FAILED"},
        { label: 'Stopped', value: "SCAN STOPPED BY USER"},
    ],
    httpMethodOptions: [
        { label: 'GET', value: 'GET' },
        { label: 'PUT', value: 'PUT' },
        { label: 'POST', value: 'POST' },
    ],
    scanRegion: [
       {label: 'USA',value: 'USA'},
       {label: 'Australia',value: 'AUS'},
       {label: 'Asia',value: 'ASIA'}
    ],
    fileUploadType: [
        { label: 'CSV', value: 'CSV_FILE' },
        { label: 'DOC', value: 'DOC_FILE' },
        { label: 'IMG', value: 'IMG_FILE' },
        { label: 'JSON', value: 'JSON_FILE' },
        { label: 'PDF', value: 'PDF_FILE' },
        { label: 'TXT', value: 'TXT_FILE' },
        { label: 'ZIP', value: 'ZIP_FILE' }
    ],
    scanSqlXssOptions: [
        { label: 'None', value: 'None' },
        { label: 'Low', value: 'Low' },
        { label: 'Medium (Default)', value: 'Medium' },
        { label: 'High', value: 'High' },
    ],
    scanFrequency: [
        { label: 'Now', value: 'now' },
        { label: 'Once', value: 'once' },
        { label: 'Monthly', value: 'monthly' },
        { label: 'Quarterly', value: 'quarterly' }
    ],
    scanRequestRate: [
        { label: 'Low (3 RPS)', value: 'Low' },
        { label: 'Medium (5 RPS)', value: 'Medium' },
        { label: 'High (10 RPS)', value: 'High' }
    ],
    scanTypeOptions: [
        { label: 'All', value: -1 },
        { label: 'Full Scan', value: 'FullScan' },
        { label: 'Delta Scan', value: 'DeltaScan' }
    ],
    businessLogicCategories: [
        { label: 'Quantity Limit Bypass', value: 'quantity_limit' },
        { label: 'Price Tampering', value: 'price_tampering' },
        { label: 'Rate Limit Bypass', value: 'rate_limit' },
        { label: 'Workflow Step Bypass', value: 'workflow_bypass' },
        { label: 'Custom (Advanced)', value: 'custom' },
    ],
    businessLogicStepMethods: [
        { label: 'GET', value: 'GET' },
        { label: 'POST', value: 'POST' },
        { label: 'PUT', value: 'PUT' },
        { label: 'PATCH', value: 'PATCH' },
        { label: 'DELETE', value: 'DELETE' },
    ],
    businessLogicStepPurposes: [
        { label: 'Setup', value: 'setup' },
        { label: 'Tamper', value: 'tamper' },
        { label: 'Verify', value: 'verify' },
    ]
};
/**
* Event
*/
export const EVENT_LOGIN_REDIRECT = "moveToLoginEvent";

/**
 * Profile Image Update
 * 
*/
export const PROFILE_IMAGE_UPDATE = "profileImageUpdate";

export const INPROGRESS_SCAN_STATUS = [
    "STARTING PASSIVE SCAN",
    "STARTING SPIDERING",
    "RUNNING SPIDER",
    "SPIDERING COMPLETED",
    "STARTING AJAX SPIDERING",
    "RUNNING AJAX SPIDER",
    "AJAX SPIDERING COMPLETED",
    "STARTING ACTIVE SCAN",
    "RUNNING ACTIVE SCAN",
    "ACTIVE SCAN COMPLETED",
    "AI-AGENT RUNNING",
    "AI-AGENT TASK COMPLETED"
];

export const SITE_SCANNED_STATUS = 1;

export const SCAN_TYPE: any = {
    "FullScan": "Full Scan",
    "DeltaScan": "Delta Scan"
}


export const SCAN_TYPE_KEY: any = {
    "FullScan": "FullScan",
    "DeltaScan": "DeltaScan"
}

export const LOGO_IMAGE_SIZE = {
    width: 467,
    height: 165,
    max: {
        width: 500,
        height: 177
    },
    min: {
        width: 400,
        height: 141
    }
}

export const BANNER_IMAGE_SIZE = {
    width: 1000,
    height: 1124,
    max: {
        width: 2000,
        height: 2248
    },
    min: {
        width: 800,
        height: 900
    }
}

export const permissionOptions = [
    { label: 'Read Only', value: 'READ_ONLY' },
    { label: 'Full Access', value: 'FULL_ACCESS' },
];

export const eventTypeOptions = [
    { label: 'Scan Completed', value: 'scan.completed' },
    { label: 'Vulnerability Found', value: 'vulnerability.found' },
    { label: 'Scan Started', value: 'scan.started' },
    { label: 'All Events', value: 'all' },
];